import React from 'react';

import { useAppContext } from 'src/components/app-context';
import { useCampaignCardContext } from '../../campaign-card-context';

import { Clickable } from 'src/components/clickable';

import { FontColor, FontEmphasis } from '@prisjakt/ui/text/variants';

import { StyledLink, StyledStoreCountLink } from './styles';

export const StoreCountLink = () => {
  const { renderMode, t } = useAppContext();

  const { handleCardOnClick, internalLink, storeCount } =
    useCampaignCardContext();

  return internalLink && storeCount ? (
    <StyledStoreCountLink>
      <Clickable
        to={internalLink}
        onClick={handleCardOnClick}
        isExternal={renderMode === 'native'}
      >
        <StyledLink color={FontColor.DARK} emphasis={FontEmphasis.MEDIUM}>
          {storeCount === 1
            ? t('campaigns', 'campaign-card.compare-prices')
            : t('campaigns', 'campaign-card.compare-prices-from-shops', {
                count: storeCount,
              })}
        </StyledLink>
      </Clickable>
    </StyledStoreCountLink>
  ) : null;
};
